<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>
<div *ngIf="isLoading">
  <div
    style="
      position: fixed;
      z-index: 900;
      width: 100vw;
      height: 100vh;
      opacity: 80;
      top: 0;
      left: 0;
      background: #e8e8e880;
    "
  ></div>
  <mat-spinner class="spinner-center" style="z-index: 1000"></mat-spinner>
</div>
<div>
  <div class="container desktop">
    <div class="row justify-content-center">
      <h1 class="lifedi-color">Dashboard</h1>
    </div>
    <!-- date box -->
    <div class="row filter">
      <label for="date" class="col-2 col-form-label"
        >ช่วงเวลาที่ต้องการ<lifedi-require></lifedi-require
      ></label>
      <div class="col-3">
        <input
          id="date"
          class="form-control"
          date-format="dd-MM-yyyy HH:mm:ss"
          [selectMode]="'range'"
          [owlDateTimeTrigger]="dtPicker"
          [owlDateTime]="dtPicker"
          [rangeSeparator]="'-'"
          dateFormat="dd-MM-yyyy"
          autocomplete="off"
          [(ngModel)]="dateTime"
          (ngModelChange)="selectDate()"
          [attr.disabled]="selectAllDate ? true : null"
        />
        <owl-date-time [pickerType]="'calendar'" #dtPicker></owl-date-time>
      </div>
      <div
        class="col-2 justify-content-center align-self-center col-form-label"
      >
        <section>
          <mat-checkbox id="checkbox" color="primary" (change)="checkboxed()">
            แสดงทั้งหมด
          </mat-checkbox>
        </section>
      </div>
    </div>
    <!-- first row -->
    <div class="row">
      <div class="col boxes" *ngIf="alldata">
        <mat-card>
          <p class="topic">
            จำนวนผู้ลงทะเบียน
            <span *ngIf="result === 'increase'"
              ><img src="assets/other/increase.png" style="width: 25px"
            /></span>
            <span *ngIf="result === 'decrease'"
              ><img src="assets/other/decrease.png" style="width: 25px"
            /></span>
          </p>
          <!-- <h4>จำนวนผู้เข้าใช้ <span><img src="assets/other/decrease.png" style="width: 25px;"/></span
        ></h4> -->
          <p
            style="
              text-align: center;
              font-size: 22px;
              font-weight: 500;
              padding-bottom: 10px;
            "
          >
            {{ alldata.firstrow.sumuser }} คน
            <span
              *ngIf="result === 'increase'"
              style="color: #28a745; font-weight: 500"
              >(+{{tofixed(alldata.firstrow.percen)}}%)</span
            >
            <span
              *ngIf="result === 'decrease'"
              style="color: #dc3545; font-weight: 500"
              >(-{{tofixed(alldata.firstrow.percen)}}%)</span
            >
            <span
              class="lifedi-color"
              *ngIf="result === 'same'"
              style="font-weight: 500"
              >(-)</span
            >
          </p>
          <div class="row">
            <div class="col"></div>
            <div class="col-4" style="text-align: center">
              <p class="subtopic">Users</p>
              <p class="value">{{ alldata.firstrow.num_user }} คน</p>
            </div>
            <div class="col-4" style="text-align: center">
              <p class="subtopic">FB</p>
              <p class="value">{{ alldata.firstrow.num_fb }} คน</p>
            </div>
            <div class="col"></div>
          </div>
        </mat-card>
      </div>
      <div class="col-5 boxes" *ngIf="alldata">
        <mat-card>
          <p style="position: absolute; right: 0; padding: 10px">
            ณ วันที่ {{ formattedDate(alldata.firstrow.date) }}
          </p>
          <p class="topic" style="padding: 20px 0">จำนวนบุคลากร</p>
          <div class="row">
            <div class="col-4" style="text-align: center">
              <p class="subtopic">อาจารย์</p>
              <p class="value">{{ alldata.firstrow.num_teacher }} คน</p>
            </div>
            <div class="col-4" style="text-align: center">
              <p class="subtopic">นักจิตวิทยา</p>
              <p class="value">{{ alldata.firstrow.num_psy }} คน</p>
            </div>
            <div class="col-4" style="text-align: center">
              <p class="subtopic">แอดมิน</p>
              <p class="value">{{ alldata.firstrow.num_admin }} คน</p>
            </div>
          </div>
        </mat-card>
      </div>
      <div class="col boxes" *ngIf="alldata">
        <mat-card>
          <p style="position: absolute; right: 0; padding: 10px">
            ณ วันที่ {{ formattedDate(alldata.firstrow.date) }}
          </p>
          <p class="topic" style="padding: 20px 0">ประเภทผู้ใช้</p>
          <div class="row">
            <div class="col"></div>
            <div class="col-4" style="text-align: center">
              <p class="subtopic">Normal</p>
              <p class="value">{{ alldata.firstrow.normal_user }} คน</p>
            </div>
            <div class="col-4" style="text-align: center">
              <p class="subtopic">Premium</p>
              <p class="value">{{ alldata.firstrow.prem_user }} คน</p>
            </div>
            <div class="col"></div>
          </div>
        </mat-card>
      </div>
    </div>
    <!-- second row -->
    <div class="row">
      <div class="col ndboxes">
        <mat-card>
          <p class="topic">รายได้</p>
          <div class="row">
            <div class="col">
              <div>
              <h3 *ngIf="alldata.secondrow.allrevenue[0].value === 0 && alldata.secondrow.allrevenue[1].value === 0 && alldata.secondrow.allrevenue[2].value === 0 && alldata.secondrow.allrevenue[3].value === 0" style="margin: 0 auto;">No data</h3>
              </div>
              <div style="margin: 0 auto; width: 80%">
                <canvas id="RevenueChart" #allcanvas></canvas>
              </div>
            </div>
            <div class="col" *ngIf="alldata">
              <div style="font-weight: bold;">คอร์สเรียน </div>
              {{ commaTs(alldata.secondrow.allrevenue[0].value) }} บาท
              <br /><br />
              <div style="font-weight: bold;">Workshop</div>
              {{ commaTs(alldata.secondrow.allrevenue[1].value) }} บาท
              <br /><br />
              <div style="font-weight: bold;">Consult</div>
              {{ commaTs(alldata.secondrow.allrevenue[2].value) }} บาท
              <br /><br />
              <div style="font-weight: bold;">แบบทดสอบ</div>
              {{ commaTs(alldata.secondrow.allrevenue[3].value) }} บาท
            </div>
          </div>
        </mat-card>
      </div>
      <div class="col ndboxes">
        <mat-card>
          <p class="topic">รอชำระ</p>
          <div class="row">
            <div class="col">
              <h3 *ngIf="alldata.secondrow.allwait[0].value === 0 && alldata.secondrow.allwait[1].value === 0 && alldata.secondrow.allwait[2].value === 0 && alldata.secondrow.allwait[3].value === 0" style="margin: 0 auto;">No data</h3>
              <div style="margin: 0 auto; width: 80%">
                <canvas id="Wait4payChart" #allcanvas></canvas>
              </div>
            </div>
            <div class="col" *ngIf="alldata">
              <div style="font-weight: bold;">คอร์สเรียน</div>
              {{ commaTs(alldata.secondrow.allwait[0].value) }} บาท <br /><br />
              <div style="font-weight: bold;">Workshop</div>
              {{ commaTs(alldata.secondrow.allwait[1].value) }} บาท <br /><br />
              <div style="font-weight: bold;">Consult</div>
              {{ commaTs(alldata.secondrow.allwait[2].value) }} บาท <br /><br />
              <div style="font-weight: bold;">แบบทดสอบ</div>
              {{ commaTs(alldata.secondrow.allwait[3].value) }} บาท
            </div>
          </div>
        </mat-card>
      </div>
    </div>
    <!-- third row -->
    <div class="row" style="padding-bottom: 15px" *ngIf="alldata">
      <div class="col">
        <mat-card style="background-color: #ff4c5a">
          <p class="rdrow" style="padding-bottom: 15px">คอร์สเรียน</p>
          <div class="row">
            <div class="col" style="text-align: left">
              <p style="color: white; padding-left: 15%">คอร์สเรียน</p>
            </div>
            <div class="col" style="text-align: right">
              <p class="subtopic2" style="color: white; padding-right: 15%">
                {{ alldata.the_rest.courses_num }}
              </p>
            </div>
          </div>
          <hr style="width: 90%; border: 1px solid white" />
          <div class="row" style="padding-top: 12px">
            <div class="col" style="text-align: left">
              <p style="color: white; padding-left: 15%">จำนวนผู้ลงทะเบียน</p>
            </div>
            <div class="col" style="text-align: right">
              <p class="subtopic2" style="color: white; padding-right: 15%">
                {{ commaTs(alldata.the_rest.course_register) }}
              </p>
            </div>
          </div>
        </mat-card>
      </div>
      <div class="col">
        <mat-card style="background-color: #ff6d64">
          <p class="rdrow" style="padding-bottom: 15px">Consult</p>
          <div class="row">
            <div class="col" style="text-align: left">
              <p style="color: white; padding-left: 15%">Consult</p>
            </div>
            <div class="col" style="text-align: right">
              <p class="subtopic2" style="color: white; padding-right: 15%">
                {{ commaTs(alldata.the_rest.consult_num) }}
              </p>
            </div>
          </div>
          <hr style="width: 90%; border: 1px solid white" />
          <div class="row" style="padding-top: 12px">
            <div class="col" style="text-align: left">
              <p style="color: white; padding-left: 15%">จำนวนผู้ลงทะเบียน</p>
            </div>
            <div class="col" style="text-align: right">
              <p class="subtopic2" style="color: white; padding-right: 15%">
                {{ commaTs(alldata.the_rest.consult_register) }}
              </p>
            </div>
          </div>
        </mat-card>
      </div>
      <div class="col">
        <mat-card style="background-color: #ffac79">
          <p class="rdrow" style="padding-bottom: 15px">Workshop</p>
          <div class="row">
            <div class="col" style="text-align: left">
              <p style="color: white; padding-left: 15%">Workshop</p>
            </div>
            <div class="col" style="text-align: right">
              <p class="subtopic2" style="color: white; padding-right: 15%">
                {{ commaTs(alldata.the_rest.workshop_num) }}
              </p>
            </div>
          </div>
          <hr style="width: 90%; border: 1px solid white" />
          <div class="row" style="padding-top: 12px">
            <div class="col" style="text-align: left">
              <p style="color: white; padding-left: 15%">จำนวนผู้ลงทะเบียน</p>
            </div>
            <div class="col" style="text-align: right">
              <p class="subtopic2" style="color: white; padding-right: 15%">
                {{ commaTs(alldata.the_rest.workshop_register) }}
              </p>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
    <!-- fourth row -->
    <div class="row" style="padding-bottom: 15px" *ngIf="alldata">
      <div class="col-4">
        <mat-card style="background-color: #ffc979">
          <p class="rdrow" style="padding-bottom: 15px">แบบทดสอบ</p>
          <div class="row">
            <div class="col" style="text-align: left">
              <p style="color: white; padding-left: 15%">แบบทดสอบ</p>
            </div>
            <div class="col" style="text-align: right">
              <p class="subtopic2" style="color: white; padding-right: 15%">
                {{ commaTs(alldata.the_rest.test_num) }}
              </p>
            </div>
          </div>
          <hr style="width: 90%; border: 1px solid white" />
          <div class="row" style="padding-top: 12px">
            <div class="col" style="text-align: left">
              <p style="color: white; padding-left: 15%">จำนวนผู้เข้าร่วม</p>
            </div>
            <div class="col" style="text-align: right">
              <p class="subtopic2" style="color: white; padding-right: 15%">
                {{ commaTs(alldata.the_rest.test_participant) }}
              </p>
            </div>
          </div>
        </mat-card>
      </div>
      <div class="col-4">
        <mat-card style="background-color: #c0de8f">
          <p class="rdrow" style="padding-bottom: 15px">ระบบวิจัย</p>
          <div class="row">
            <div class="col" style="text-align: left">
              <p style="color: white; padding-left: 15%">งานวิจัย</p>
            </div>
            <div class="col" style="text-align: right">
              <p class="subtopic2" style="color: white; padding-right: 15%">
                {{ commaTs(alldata.the_rest.research_num) }}
              </p>
            </div>
          </div>
          <hr style="width: 90%; border: 1px solid white" />
          <div class="row" style="padding-top: 12px">
            <div class="col" style="text-align: left">
              <p style="color: white; padding-left: 15%">จำนวนผู้เข้าร่วม</p>
            </div>
            <div class="col" style="text-align: right">
              <p class="subtopic2" style="color: white; padding-right: 15%">
                {{ commaTs(alldata.the_rest.research_participant) }}
              </p>
            </div>
          </div>
        </mat-card>
      </div>
      <div class="col-2">
        <mat-card
          style="
            background-color: #77d8b5;
            height: 201px;
            display: grid;
            vertical-align: middle;
          "
        >
          <div style="text-align: right">
            <p class="subtopic2" style="color: white">
              {{ commaTs(alldata.the_rest.news_num) }}
            </p>
          </div>
          <div style="text-align: right">
            <p style="color: white">ข่าว</p>
          </div>
          <div style="text-align: right">
            <p class="subtopic2" style="color: white">
              {{ commaTs(alldata.the_rest.news_reader) }}
            </p>
          </div>
          <div style="text-align: right">
            <p style="color: white">จำนวนผู้อ่าน</p>
          </div>
        </mat-card>
      </div>
      <div class="col-2">
        <mat-card
          style="
            background-color: #bd9cd4;
            height: 201px;
            display: grid;
            vertical-align: middle;
          "
        >
          <div style="text-align: right">
            <p class="subtopic2" style="color: white">
              {{ commaTs(alldata.the_rest.article_num) }}
            </p>
          </div>
          <div style="text-align: right">
            <p style="color: white">บทความ</p>
          </div>
          <div style="text-align: right">
            <p class="subtopic2" style="color: white">
              {{ commaTs(alldata.the_rest.article_reader) }}
            </p>
          </div>
          <div style="text-align: right">
            <p style="color: white">จำนวนผู้อ่าน</p>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
  <div class="container ipad">
    <div class="row justify-content-center">
      <h1 class="lifedi-color">Dashboard</h1>
    </div>
    <div class="row filter">
      <label for="date" class="col-3 col-form-label"
        >ช่วงเวลาที่ต้องการ<lifedi-require></lifedi-require
      ></label>
      <div class="col-6">
        <input
          id="date"
          class="form-control"
          date-format="dd-MM-yyyy HH:mm:ss"
          [selectMode]="'range'"
          [owlDateTimeTrigger]="dtPicker"
          [owlDateTime]="dtPicker"
          [rangeSeparator]="'-'"
          dateFormat="dd-MM-yyyy"
          autocomplete="off"
          [(ngModel)]="dateTime"
          (ngModelChange)="selectDate()"
          [attr.disabled]="selectAllDate ? true : null"
        />
        <owl-date-time [pickerType]="'calendar'" #dtPicker></owl-date-time>
      </div>
      <div
        class="col-3 justify-content-center align-self-center col-form-label"
      >
        <section>
          <mat-checkbox id="alwaysOpen" color="primary" (change)="checkboxed()">
            แสดงทั้งหมด
          </mat-checkbox>
        </section>
      </div>
    </div>
    <div class="row" style="padding-bottom: 15px" *ngIf="alldata">
      <div class="col-12">
        <mat-card style="margin: 0 auto">
          <div class="row">
            <p style="position: absolute; right: 0; padding-right: 15px">
              ณ วันที่ {{ formattedDate(alldata.firstrow.date) }}
            </p>
          </div>
          <div class="row">
            <p class="topic" style="padding: 20px 0; margin: 0 auto">
              จำนวนบุคลากร
            </p>
          </div>
          <div class="row">
            <div class="col-4" style="text-align: center">
              <p class="subtopic">อาจารย์</p>
              <p class="value">{{ alldata.firstrow.num_teacher }} คน</p>
            </div>
            <div class="col-4" style="text-align: center">
              <p class="subtopic">นักจิตวิทยา</p>
              <p class="value">{{ alldata.firstrow.num_psy }} คน</p>
            </div>
            <div class="col-4" style="text-align: center">
              <p class="subtopic">แอดมิน</p>
              <p class="value">{{ alldata.firstrow.num_admin }} คน</p>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
    <div class="row" *ngIf="alldata">
      <div class="col boxes">
        <mat-card>
          <p class="topic">
            จำนวนผู้ลงทะเบียน
            <span *ngIf="result === 'increase'"
              ><img src="assets/other/increase.png" style="width: 25px"
            /></span>
            <span *ngIf="result === 'decrease'"
              ><img src="assets/other/decrease.png" style="width: 25px"
            /></span>
          </p>
          <p
            style="
              text-align: center;
              font-size: 22px;
              font-weight: 500;
              padding-bottom: 10px;
            "
          >
            {{ alldata.firstrow.sumuser }} คน
            <span
              *ngIf="result === 'increase'"
              style="color: #28a745; font-weight: 500"
              >({{ alldata.firstrow.percen }})</span
            >
            <span
              *ngIf="result === 'decrease'"
              style="color: #dc3545; font-weight: 500"
              >({{ alldata.firstrow.percen }})</span
            >
            <span
              class="lifedi-color"
              *ngIf="result === 'same'"
              style="font-weight: 500"
              >(-)</span
            >
          </p>
          <div class="row">
            <div class="col"></div>
            <div class="col-4" style="text-align: center">
              <p class="subtopic">Users</p>
              <p class="value">{{ alldata.firstrow.num_user }} คน</p>
            </div>
            <div class="col-4" style="text-align: center">
              <p class="subtopic">FB</p>
              <p class="value">{{ alldata.firstrow.num_fb }} คน</p>
            </div>
            <div class="col"></div>
          </div>
        </mat-card>
      </div>
      <div class="col boxes">
        <mat-card>
          <p style="position: absolute; right: 0; padding: 10px">
            ณ วันที่ {{ formattedDate(alldata.firstrow.date) }}
          </p>
          <p class="topic" style="padding: 20px 0; margin: 0 auto">
            ประเภทผู้ใช้
          </p>
          <div class="row">
            <div class="col"></div>
            <div class="col-4" style="text-align: center">
              <p class="subtopic">Normal</p>
              <p class="value">{{ alldata.firstrow.normal_user }} คน</p>
            </div>
            <div class="col-4" style="text-align: center">
              <p class="subtopic">Premium</p>
              <p class="value">{{ alldata.firstrow.prem_user }} คน</p>
            </div>
            <div class="col"></div>
          </div>
        </mat-card>
      </div>
    </div>
    <!-- second row -->
    <div class="row">
      <div class="col ndboxes">
        <mat-card>
          <p class="topic">รายได้</p>
          <div class="row">
            <div class="col">
              <h3 *ngIf="alldata.secondrow.allrevenue[0].value === 0 && alldata.secondrow.allrevenue[1].value === 0 && alldata.secondrow.allrevenue[2].value === 0 && alldata.secondrow.allrevenue[3].value === 0" style="margin: 0 auto;">No data</h3>
              <div style="margin: 0 auto; width: 80%">
                <canvas id="RevenueChartIpad" #allcanvas></canvas>
              </div>
            </div>
            <div class="col" *ngIf="alldata">
              <div style="font-weight: bold;">คอร์สเรียน</div>
              {{ commaTs(alldata.secondrow.allrevenue[0].value) }} บาท
              <br /><br />
              <div style="font-weight: bold;">workshop</div>
              {{ commaTs(alldata.secondrow.allrevenue[1].value) }} บาท
              <br /><br />
              <div style="font-weight: bold;">consult</div>
              {{ commaTs(alldata.secondrow.allrevenue[2].value) }} บาท
              <br /><br />
              <div style="font-weight: bold;">แบบทดสอบ</div>
              {{ commaTs(alldata.secondrow.allrevenue[3].value) }} บาท
            </div>
          </div>
        </mat-card>
      </div>
      <div class="col ndboxes">
        <mat-card>
          <p class="topic">รอชำระ</p>
          <div class="row">
            <div class="col">
              <h3 *ngIf="alldata.secondrow.allwait[0].value === 0 && alldata.secondrow.allwait[1].value === 0 && alldata.secondrow.allwait[2].value === 0 && alldata.secondrow.allwait[3].value === 0" style="margin: 0 auto;">No data</h3>
              <div style="margin: 0 auto; width: 80%">
                <canvas id="Wait4payChartIpad" #allcanvas></canvas>
              </div>
            </div>
            <div class="col" *ngIf="alldata">
              <div style="font-weight: bold;">คอร์สเรียน</div>
              {{ commaTs(alldata.secondrow.allwait[0].value) }} บาท <br /><br />
              <div style="font-weight: bold;">workshop</div>
              {{ commaTs(alldata.secondrow.allwait[1].value) }} บาท <br /><br />
              <div style="font-weight: bold;">consult</div>
              {{ commaTs(alldata.secondrow.allwait[2].value) }} บาท <br /><br />
              <div style="font-weight: bold;">แบบทดสอบ</div> <br />
              {{ commaTs(alldata.secondrow.allwait[3].value) }} บาท
            </div>
          </div>
        </mat-card>
      </div>
    </div>
    <!-- fourth row -->
    <div class="row" style="padding-bottom: 15px" *ngIf="alldata">
      <div class="col">
        <mat-card style="background-color: #ff4c5a">
          <p class="rdrow" style="padding-bottom: 15px">คอร์สเรียน</p>
          <div class="row">
            <div class="col" style="text-align: left">
              <p style="color: white; padding-left: 15%">คอร์สเรียน</p>
            </div>
            <div class="col" style="text-align: right">
              <p class="subtopic2" style="color: white; padding-right: 15%">
                {{ alldata.the_rest.courses_num }}
              </p>
            </div>
          </div>
          <hr style="width: 90%; border: 1px solid white" />
          <div class="row" style="padding-top: 12px">
            <div class="col" style="text-align: left">
              <p style="color: white; padding-left: 15%">จำนวนผู้ลงทะเบียน</p>
            </div>
            <div class="col" style="text-align: right">
              <p class="subtopic2" style="color: white; padding-right: 15%">
                {{ commaTs(alldata.the_rest.course_register) }}
              </p>
            </div>
          </div>
        </mat-card>
      </div>
      <div class="col">
        <mat-card style="background-color: #ff6d64">
          <p class="rdrow" style="padding-bottom: 15px">Consult</p>
          <div class="row">
            <div class="col" style="text-align: left">
              <p style="color: white; padding-left: 15%">Consult</p>
            </div>
            <div class="col" style="text-align: right">
              <p class="subtopic2" style="color: white; padding-right: 15%">
                {{ commaTs(alldata.the_rest.consult_num) }}
              </p>
            </div>
          </div>
          <hr style="width: 90%; border: 1px solid white" />
          <div class="row" style="padding-top: 12px">
            <div class="col" style="text-align: left">
              <p style="color: white; padding-left: 15%">จำนวนผู้ลงทะเบียน</p>
            </div>
            <div class="col" style="text-align: right">
              <p class="subtopic2" style="color: white; padding-right: 15%">
                {{ commaTs(alldata.the_rest.consult_register) }}
              </p>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
    <!-- fifth row -->
    <div class="row" style="padding-bottom: 15px" *ngIf="alldata">
      <div class="col">
        <mat-card style="background-color: #ffac79">
          <p class="rdrow" style="padding-bottom: 15px">Workshop</p>
          <div class="row">
            <div class="col" style="text-align: left">
              <p style="color: white; padding-left: 15%">Workshop</p>
            </div>
            <div class="col" style="text-align: right">
              <p class="subtopic2" style="color: white; padding-right: 15%">
                {{ commaTs(alldata.the_rest.workshop_num) }}
              </p>
            </div>
          </div>
          <hr style="width: 90%; border: 1px solid white" />
          <div class="row" style="padding-top: 12px">
            <div class="col" style="text-align: left">
              <p style="color: white; padding-left: 15%">จำนวนผู้ลงทะเบียน</p>
            </div>
            <div class="col" style="text-align: right">
              <p class="subtopic2" style="color: white; padding-right: 15%">
                {{ commaTs(alldata.the_rest.workshop_register) }}
              </p>
            </div>
          </div>
        </mat-card>
      </div>
      <div class="col">
        <mat-card style="background-color: #ffc979">
          <p class="rdrow" style="padding-bottom: 15px">แบบทดสอบ</p>
          <div class="row">
            <div class="col" style="text-align: left">
              <p style="color: white; padding-left: 15%">แบบทดสอบ</p>
            </div>
            <div class="col" style="text-align: right">
              <p class="subtopic2" style="color: white; padding-right: 15%">
                {{ commaTs(alldata.the_rest.test_num) }}
              </p>
            </div>
          </div>
          <hr style="width: 90%; border: 1px solid white" />
          <div class="row" style="padding-top: 12px">
            <div class="col" style="text-align: left">
              <p style="color: white; padding-left: 15%">จำนวนผู้เข้าร่วม</p>
            </div>
            <div class="col" style="text-align: right">
              <p class="subtopic2" style="color: white; padding-right: 15%">
                {{ commaTs(alldata.the_rest.test_participant) }}
              </p>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
    <!-- sixth row -->
    <div class="row" style="padding-bottom: 15px" *ngIf="alldata">
      <div class="col-6">
        <mat-card style="background-color: #c0de8f">
          <p class="rdrow" style="padding-bottom: 15px">ระบบวิจัย</p>
          <div class="row">
            <div class="col" style="text-align: left">
              <p style="color: white; padding-left: 15%">งานวิจัย</p>
            </div>
            <div class="col" style="text-align: right">
              <p class="subtopic2" style="color: white; padding-right: 15%">
                {{ commaTs(alldata.the_rest.research_num) }}
              </p>
            </div>
          </div>
          <hr style="width: 90%; border: 1px solid white" />
          <div class="row" style="padding-top: 12px">
            <div class="col" style="text-align: left">
              <p style="color: white; padding-left: 15%">จำนวนผู้เข้าร่วม</p>
            </div>
            <div class="col" style="text-align: right">
              <p class="subtopic2" style="color: white; padding-right: 15%">
                {{ commaTs(alldata.the_rest.research_participant) }}
              </p>
            </div>
          </div>
        </mat-card>
      </div>
      <div class="col-3">
        <mat-card
          style="
            background-color: #77d8b5;
            height: 201px;
            display: grid;
            vertical-align: middle;
          "
        >
          <div style="text-align: right">
            <p class="subtopic2" style="color: white">
              {{ commaTs(alldata.the_rest.news_num) }}
            </p>
          </div>
          <div style="text-align: right">
            <p style="color: white">ข่าว</p>
          </div>
          <div style="text-align: right">
            <p class="subtopic2" style="color: white">
              {{ commaTs(alldata.the_rest.news_reader) }}
            </p>
          </div>
          <div style="text-align: right">
            <p style="color: white">จำนวนผู้อ่าน</p>
          </div>
        </mat-card>
      </div>
      <div class="col-3">
        <mat-card
          style="
            background-color: #bd9cd4;
            height: 201px;
            display: grid;
            vertical-align: middle;
          "
        >
          <div style="text-align: right">
            <p class="subtopic2" style="color: white">
              {{ commaTs(alldata.the_rest.article_num) }}
            </p>
          </div>
          <div style="text-align: right">
            <p style="color: white">บทความ</p>
          </div>
          <div style="text-align: right">
            <p class="subtopic2" style="color: white">
              {{ commaTs(alldata.the_rest.article_reader) }}
            </p>
          </div>
          <div style="text-align: right">
            <p style="color: white">จำนวนผู้อ่าน</p>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div>
